export default __webpack_public_path__ + "static/media/Gelato Brownie.643ae17a.jpg";